<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">

    <div *ngFor="let formField of formFields" class="form-group">
      <app-input-relatorios [input]="formField" [form]="form"></app-input-relatorios>
    </div>

    <div *ngIf="formularioDados | json" class="form-group">
    </div>


    <p class="text-danger">* - Campo obrigatório </p>


    <div class="form-group d-flex justify-content-between">
      <button type="button" class="btn btn-lg btn-secondary" (click)="fechaModal()">Fechar</button>
      <button type="submit" class="btn btn-lg btn-primary" [disabled]="!form.valid">Gerar Relatório</button>
    </div>
  </form>

  <app-modal-avaliacao *ngIf="avaliacaoService.exibirModalAvaliacao" [momento]="'RELATORIO'" (closeModal)="fecharModalAvaliacao()"></app-modal-avaliacao> 
</div>
